// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".add-client-modal .form-control{border-radius:0}", "",{"version":3,"sources":["/workspace/app/javascript/account-app/features/campaigns/campaign-clients-modal.styles.scss"],"names":[],"mappings":"AAGE,gCACE,eAAA","file":"campaign-clients-modal.styles.scss","sourcesContent":["@import \"app/assets/stylesheets/v2/framework/core\";\n\n.add-client-modal {\n  .form-control {\n    border-radius: 0;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
